module.exports = __webpack_public_path__ + "static/media/02.6ff157a8.jpg";